import { useState } from 'react'
import { useSelector } from 'react-redux'

import { btnTypes } from 'components/PreClass/Checklist/components/common/Button'
import { MOOD } from 'components/Tiles/Modes/Greetings/constants'
import { checklistStatusTypes } from 'constants/checklist'
import { classStore } from 'helpers/room'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { dispatchSetIsInteractionMode } from 'store/dispatcher'
import { _checklistStatus } from 'store/selectors/Checklist'
import { _twilioToken } from 'store/selectors/Room'

const { SUCCESS } = checklistStatusTypes
const { FUN } = MOOD

const useVideoConnect = () => {
    const [loading, setLoading] = useState()

    const shouldDisable = useSelector(_checklistStatus) !== SUCCESS
    const twilioToken = useSelector(_twilioToken)
    const { connect } = useVideoContext()

    const handleClick = async mood => {
        dispatchSetIsInteractionMode(mood)
        await connect(twilioToken)
        classStore.set('on')
    }

    return [
        {
            id: 1,
            text: 'join class',
            type: btnTypes.SUCCESS,
            trigger: FUN,
            onClick: async () => {
                setLoading(1)
                await handleClick(FUN)
            },
            disabled: !!loading || shouldDisable,
            isLoading: loading === 1 || shouldDisable,
        },
    ]
}

export default useVideoConnect
